<template>
	<div id="app">
		<link rel="stylesheet" href="//fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic">
    <link href="https://fonts.googleapis.com/css?family=Poppins:300,400" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css?family=Roboto+Slab:300,400" rel="stylesheet">
		<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css">
		<link v-if="favicon" rel="icon" :href="favicon">
		<link v-else rel="icon" href="https://storage.googleapis.com/protopia/images/protopia_favicon.png">
		<router-view :auth="auth" :authenticated="authenticated">
    </router-view>
	</div>
</template>
<script>
import AuthService from "./services/AuthService";
import API from "./services/API";
import EventBus from './assets/js/EventBus';

const auth = new AuthService();
const { login, logout, authenticated, authNotifier } = auth;

export default {
  name: "App",
  data() {
    authNotifier.on("authChange", authState => {
      this.authenticated = authState.authenticated;
    });
    return {
      auth,
      authenticated,
      favicon: null,
    communityCache: new Map(), // Using Map for O(1) lookups
    lastCacheUpdate: 0,
    CACHE_TTL: 5 * 60 * 1000 // 5 minutes cache TTL
    };
  },
  created() {
    // Listen for favicon change events
    EventBus.$on('change-favicon', (newFaviconURL) => {
      console.log("newFaviconURL", newFaviconURL);
      this.favicon = newFaviconURL;
    });
  },
  beforeDestroy() {
    // Clean up event listener
    EventBus.$off('change-favicon');
  },
  watch: {
    favicon: {
      immediate: true,
      handler(newFaviconURL) {
        console.log('App: Favicon watch triggered', newFaviconURL);
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = newFaviconURL || 'https://storage.googleapis.com/protopia/images/protopia_favicon.png';
        const head = document.getElementsByTagName('head')[0];
        const existingLink = document.querySelector("link[rel*='icon']");
        if (existingLink) {
          head.removeChild(existingLink);
        }
        head.appendChild(link);
      }
    }

  },
  methods: {
    login,
    logout,
    async fetchAndCacheCommunities() {
    try {
      const api = new API();
      const response = await api.get('communities/all');
      // Transform array to Map for O(1) lookups
      this.communityCache.clear();
      response.data.forEach(community => {
        this.communityCache.set(community._id, community);
      });
      this.lastCacheUpdate = Date.now();
    } catch (error) {
      console.error('Error fetching communities:', error);
      throw error;
    }
  },
  extractCommunityId(path) {
    const match = path.match(/\/communities\/([^\/]+)/);
    console.log("match", match);
    return match ? match[1] : null;

  }
  }
};
</script>
<style>
body {
  background-color: #F3F8FB;
}

.md-app-content {
  background-color: #F3F8FB !important;
  border: none !important;
}
.header {
  background-color: #131416;
  color: #91799f;
  margin: 0px;
  text-align: center;
}
#app {
  margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue